/* eslint-disable prefer-destructuring */

export const Intl = window.Intl;
export const setTimeout = window.setTimeout;
